import {
  errorUnlessOk,
  buildRequestWithAuth,
  headersBackendSeguros,
} from "./utils";
import environment from "~libs/environment";
import { paths, novedadesPath } from "~constants/referenceNames";
import {
  GetNovedadResponse,
  GetNovedadesRequest,
  GetNovedadesResponse,
} from "./types";

let mockActive = false;
let mockActiveNovedades = false;

const novedades = () => {
  return {
    getNovedad: async (id: string): Promise<GetNovedadResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      let url = environment.segurosUrl + paths[novedadesPath] + "/" + id;

      if (mockActive) {
        return getNovedadMock();
      } else {
        try {
          const response = await fetch(url, request);
          errorUnlessOk(response);
          return response.json();
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
    },

    getNovedades: async (
      data: GetNovedadesRequest
    ): Promise<GetNovedadesResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      let parameters = `Skip=${data.skip}&Take=${data.take}`;

      parameters = data.searchCriteria
        ? parameters + `&SearchCriteria=${data.searchCriteria}`
        : parameters;

      parameters = data.negocio
        ? parameters + `&Negocio=${data.negocio}`
        : parameters;

      parameters = data.compania
        ? parameters + `&Compania=${data.compania}`
        : parameters;

      parameters = data.tipoNovedad
        ? parameters + `&TipoNovedad=${data.tipoNovedad}`
        : parameters;

      parameters = data.fechaNovedadDesde
        ? parameters +
          `&FechaNovedadDesde=${data.fechaNovedadDesde.toISOString()}`
        : parameters;

      if (data.fechaNovedadHasta) {
        data.fechaNovedadHasta.setHours(23, 59, 59);
        parameters =
          parameters +
          `&FechaNovedadHasta=${data.fechaNovedadHasta.toISOString()}`;
      }

      parameters = data.inicioVigenciaDesde
        ? parameters +
          `&InicioVigenciaDesde=${data.inicioVigenciaDesde.toISOString()}`
        : parameters;

      if (data.inicioVigenciaHasta) {
        data.inicioVigenciaHasta.setHours(23, 59, 59);
        parameters =
          parameters +
          `&InicioVigenciaHasta=${data.inicioVigenciaHasta.toISOString()}`;
      }

      parameters =
        parameters +
        "&SortBy=FechaCreacionNovedad:desc,PolizaVigenciaDesde:asc";

      let url =
        environment.segurosUrl + paths[novedadesPath] + "?" + parameters;

      try {
        if (mockActiveNovedades) {
          return getNovedadesMock(data);
        } else {
          const response = await fetch(url, request);
          errorUnlessOk(response);
          return await response.json();
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  };
};

export { novedades };

const getNovedadMock = (): GetNovedadResponse => {
  return {
    id: "58d619e7-cec4-4e6b-9ecd-cbe48a71d3bc",
    polizaId: "poliza-id",
    negocio: "MercadoAbierto",
    tipoNovedad: "Emision",
    compania: "Sancor",
    rama: "Automotores",
    numeroPoliza: "8439954",
    orden: 8,
    dominio: "OZY103",
    fechaCreacionNovedad: "2019-06-27T18:43:54.942Z",
    fechaEmision: "2019-03-28T03:00:00.000Z",
    fechaRenovacion: undefined,
    polizaVigenciaDesde: "2019-03-28T03:00:00.000Z",
    polizaVigenciaHasta: "2019-09-28T03:00:00.000Z",
    fechaAnulacion: undefined,
    cantidadCuotas: 6,
    primaTotal: 8736.6,
    premioTotal: 12575.0,
    renuevaA: undefined,
    codigoOrganizador: "102224",
    codigoProductor: "227128",
    tipoCobertura: "9",
    tipoDocumentoAsegurado: "DNI",
    numeroDocumentoAsegurado: "92969018",
    nombreCompletoAsegurado: "SAAVEDRA ARAVENA SAMUEL IVAN",
    cuotas: [
      {
        numeroCuota: 1,
        prima: 1456.1,
        premio: 2100.0,
        fechaDesde: "2019-03-28T03:00:00.000Z",
        fechaHasta: "2019-04-28T03:00:00.000Z",
        fechaVencimiento: "2019-03-28T03:00:00.000Z",
      },
    ],
    urlPoliza: "http://example.com/poliza",
    urlTarjeta: "http://example.com/tarjeta",
    urlCedulaMercosur: "http://example.com/cedula",
    urlCuponera: "http://example.com/cuponera",
    sumaAsegurada: 10000,
  };
};

const getNovedadesMock = (data: GetNovedadesRequest): GetNovedadesResponse => {
  const novedades: GetNovedadResponse[] = [
    {
      id: "2653903c-bdc9-4ed0-afef-1794ce6cb179",
      polizaId: "some-poliza-id",
      negocio: "MercadoAbierto",
      tipoNovedad: "Siniestro",
      compania: "Sancor",
      rama: "Automotores",
      numeroPoliza: "8946730",
      orden: 1,
      dominio: "LWV662",
      sumaAsegurada: 355000.0,
      fechaCreacionNovedad: "2020-01-03T20:12:54.407Z",
      fechaEmision: undefined,
      fechaRenovacion: undefined,
      polizaVigenciaDesde: "2020-01-23T03:00:00.000Z",
      polizaVigenciaHasta: "2020-07-23T03:00:00.000Z",
      fechaAnulacion: undefined,
      cantidadCuotas: 5,
      primaTotal: undefined,
      premioTotal: undefined,
      renuevaA: undefined,
      codigoOrganizador: "102446",
      codigoProductor: "228075",
      tipoCobertura: "Total",
      tipoDocumentoAsegurado: "DNI",
      numeroDocumentoAsegurado: "30707621",
      nombreCompletoAsegurado: "ALVAREZ PEREZ MARIBEL",
      cuotas: [],
      urlPoliza: "http://example.com/poliza",
      urlTarjeta: "http://example.com/tarjeta",
      urlCedulaMercosur: "http://example.com/cedula",
      urlCuponera: "http://example.com/cuponera",
    },
  ];

  return {
    novedades: novedades,
    totalRegistros: novedades.length,
  };
};
